// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"FY-z","inlineTitle":"GY-z","sponsoredAdsWrapper":"HY-z","marketplaceRecosWrapper":"IY-z","brandShopTheLookWrapper":"JY-z"};